module.exports = __webpack_public_path__ + "css/ecube.845a36aa.css";